import React from 'react';
import { useDispatch } from 'react-redux';
import { compose } from 'redux';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { alertRulesActions, alertRulesTypes } from 'app-components/flux/alert-rules';
import QIconButton from 'components/QIconButton';
import QTip from 'components/QuickenControls/QTip';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

import EmailDisabled from 'assets/icons/notification/email-switch-disabled.svg';
import EmailOff from 'assets/icons/notification/email-switch-off.svg';
import EmailOn from 'assets/icons/notification/email-switch-on.svg';

import PushDisabled from 'assets/icons/notification/push-switch-disabled.svg';
// NOTE: The Push svg is not centered properly, so the padding is slightly adjusted so the outline actually appears correct
import PushOff from 'assets/icons/notification/push-switch-off.svg';
import PushOn from 'assets/icons/notification/push-switch-on.svg';

import NotificationSubtitleLegacy from './notificationSubtitleLEGACY';

const useStyles = makeStyles()((theme) => ({
  gridItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
  notificationRowSubtitles: {
    display: 'flex',
    paddingLeft: theme.spacing(2),
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}));

const NotificationRowSettingLegacy = (props) => {
  const { classes } = useStyles();
  const { title, firstSwitchBool, secondSwitchBool, alertRule } = props;
  const dispatch = useDispatch();

  const emailDisabled = !alertRule.preferences.isEmailSupported;
  const pushDisabled = !alertRule.preferences.isPushSupported;

  const getEmailIcon = () => {
    let icon = EmailOff;
    if (!emailDisabled && firstSwitchBool) {
      icon = EmailOn;
    } else if (emailDisabled) {
      icon = EmailDisabled;
    }
    return icon;
  };

  const getPushIcon = () => {
    let icon = PushOff;
    if (!pushDisabled && secondSwitchBool) {
      icon = PushOn;
    } else if (pushDisabled) {
      icon = PushDisabled;
    }
    return icon;
  };

  return (
    <Grid container className={classes.gridItem}>
      <Grid item sm={7} className={classes.notificationRowSubtitles}>
        <Typography variant='titleMedium'>{title}</Typography>
        <NotificationSubtitleLegacy title={title} alertRule={alertRule} />
      </Grid>
      <Grid item md={2} sm={2} xs={6}>
        <QTip title={emailDisabled ? 'Email not supported' : `Turn ${firstSwitchBool ? 'off' : 'on'} email`}>
          <QIconButton
            id={`toggle-${title}-email-button`}
            aria-label='Toggle Email'
            onClick={() =>
              dispatch(
                alertRulesActions.updateAlertRule(
                  alertRulesTypes.mkAlertRuleUpdate({
                    id: alertRule.id,
                    preferences: { isEnabled: true, isEmailOk: !firstSwitchBool },
                  }),
                ),
              )
            }
            disabled={emailDisabled}
            size='small'
          >
            <img alt='email' src={getEmailIcon()} />
          </QIconButton>
        </QTip>
      </Grid>
      <Grid item md={2} sm={2} xs={6}>
        <QTip title={pushDisabled ? 'Push not supported' : `Turn ${secondSwitchBool ? 'off' : 'on'} push`}>
          <QIconButton
            id={`toggle-${title}-push-button`}
            aria-label='Toggle Push'
            onClick={() =>
              dispatch(
                alertRulesActions.updateAlertRule(
                  alertRulesTypes.mkAlertRuleUpdate({
                    id: alertRule.id,
                    preferences: { isEnabled: true, isPushOk: !secondSwitchBool },
                  }),
                ),
              )
            }
            disabled={pushDisabled}
            size='medium'
            style={{
              marginTop: -0.5,
              paddingBottom: '12px',
              paddingLeft: '12px',
              paddingTop: '9px',
              paddingRight: '9px',
            }}
          >
            <img alt='Push' src={getPushIcon()} />
          </QIconButton>
        </QTip>
      </Grid>
    </Grid>
  );
};
NotificationRowSettingLegacy.propTypes = {
  title: PropTypes.string,
  firstSwitchBool: PropTypes.bool,
  secondSwitchBool: PropTypes.bool,
  alertRule: PropTypes.any,
};
export default compose()(NotificationRowSettingLegacy);
